import React from 'react'
import PropTypes from 'prop-types'
import PageSizeControl from './PageSizeControl'
import PageControl from './PageControl'
import { PaginationWrapper } from './styles'

export const Pagination = ({
  totalItems,
  currentPage,
  defaultPageSize,
  expandedPagesCount,
  expandThreshold,
  onPageChange,
  onPageSizeChange,
  pageSizeControlSuffix
}) => {
  const hasItemsToPaginate = totalItems !== 0

  return (
    <>
      {hasItemsToPaginate && <PaginationWrapper>
        <PageSizeControl
          defaultPageSize={defaultPageSize}
          totalItems={totalItems}
          onPageSizeChange={onPageSizeChange}
          pageSizeControlSuffix={pageSizeControlSuffix}

        />
        <PageControl
          totalItems={totalItems}
          defaultPageSize={defaultPageSize}
          currentPage={currentPage}
          expandedPagesCount={expandedPagesCount}
          expandThreshold={expandThreshold}
          onPageChange={onPageChange}
        />
      </PaginationWrapper>}
    </>
  )
}

export default Pagination

Pagination.propTypes = {
  totalItems: PropTypes.number,
  currentPage: PropTypes.number,
  defaultPageSize: PropTypes.number,
  expandedPagesCount: PropTypes.number,
  expandThreshold: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  pageSizeControlSuffix: PropTypes.string
}
